import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const FEATURES = [
  { icon: 'ri-microscope-line', title: 'Scientifically Formulated', desc: 'Every product is developed using the latest veterinary science, ensuring efficacy and safety for all major livestock species.' },
  { icon: 'ri-shield-star-line', title: 'Quality Guaranteed', desc: 'Manufactured under strict quality controls by Metsun Pharma, 8km Lahore GT Road Rawat Rawalpindi, ensuring Nutraceuticals-grade standards in every batch.' },
  { icon: 'ri-truck-line', title: 'Nationwide Distribution', desc: 'Reliable supply chain ensuring farmers and distributors across Pakistan receive products on time, every time.' },
  { icon: 'ri-customer-service-2-line', title: 'Expert Support', desc: 'Our team of veterinary advisors are available via WhatsApp to answer your questions and recommend the right solutions.' },
  { icon: 'ri-plant-line', title: 'Farmer-Proven Results', desc: 'Trusted by thousands of Pakistani farmers who have seen measurable gains in milk production, growth rates, and animal health.' },
  { icon: 'ri-recycle-line', title: 'Sustainable Practices', desc: 'Responsible manufacturing processes designed to deliver maximum animal benefit with minimal environmental impact.' },
];

export default function WhyChooseUs() {
  const { ref, isVisible } = useScrollAnimation();
  const { ref: ref2, isVisible: isVisible2 } = useScrollAnimation();

  return (
    <section
      ref={ref as React.RefObject<HTMLElement>}
      className="py-24 px-4 md:px-8"
      style={{ background: '#0E1218' }}
    >
      <div className="max-w-7xl mx-auto">
        {/* Top row: image + text */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-24">
          <div className={`reveal ${isVisible ? 'visible' : ''}`}>
            <div className="relative rounded-2xl overflow-hidden" style={{ height: '420px' }}>
              <img
                src="https://readdy.ai/api/search-image?query=farmer%20checking%20healthy%20dairy%20cattle%20livestock%20Pakistan%20farm%20morning%20light%20documentary%20authentic%20photography%20agricultural%20workers%20livestock%20herd%20green%20fields&width=700&height=500&seq=why1&orientation=landscape"
                alt="Farmer with healthy livestock"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-dark/60 to-transparent" />
              {/* Floating stat card */}
              <div className="absolute bottom-6 left-6 glass rounded-xl px-5 py-4">
                <p className="font-poppins font-bold text-2xl text-accent">500+</p>
                <p className="text-xs text-text-soft mt-0.5">Trusted Products</p>
              </div>
            </div>
          </div>

          <div className={`reveal reveal-delay-2 ${isVisible ? 'visible' : ''}`}>
            <p className="text-accent text-xs font-semibold tracking-[3px] uppercase mb-3">
              Why Hamva
            </p>
            <h2 className="font-poppins font-bold text-3xl md:text-4xl text-white mb-6">
              Pakistan&apos;s Most Trusted Veterinary Brand
            </h2>
            <p className="text-text-muted text-base leading-relaxed mb-8">
              For over 15 years, Hamva Pharmaceuticals has been at the forefront of animal health innovation in Pakistan. Our products are scientifically formulated, quality-tested, and trusted by farmers nationwide.
            </p>
            <div className="space-y-4">
              {['ISO-grade manufacturing standards', 'Formulated by veterinary specialists', 'Results backed by farm-level trials', 'Direct WhatsApp support available'].map((item) => (
                <div key={item} className="flex items-center gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-checkbox-circle-fill text-accent text-xl" />
                  </div>
                  <span className="text-text-soft text-sm">{item}</span>
                </div>
              ))}
            </div>
            <a
              href="https://wa.me/923007321011"
              target="_blank"
              rel="noopener noreferrer"
              className="wa-btn inline-flex items-center gap-2.5 mt-8 px-7 py-3.5 rounded-full text-sm font-semibold text-white cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-lg" />
              Talk to Our Experts
            </a>
          </div>
        </div>

        {/* Feature grid */}
        <div
          ref={ref2 as React.RefObject<HTMLDivElement>}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5"
        >
          {FEATURES.map((feat, i) => (
            <div
              key={i}
              className={`group rounded-2xl p-6 border border-white/5 hover:border-accent/25 transition-all duration-300 reveal reveal-delay-${(i % 3) + 1} ${isVisible2 ? 'visible' : ''}`}
              style={{ background: '#131923' }}
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-accent/10 mb-4 group-hover:bg-accent/20 transition-colors duration-300">
                <i className={`${feat.icon} text-accent text-xl`} />
              </div>
              <h3 className="font-poppins font-semibold text-base text-white mb-2">{feat.title}</h3>
              <p className="text-text-muted text-sm leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
